import './style.css';

const NotFound = () => (
   <h1 className='notFound'>404</h1>
);

export default NotFound;
